









































import { vxm } from '../../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import router from '../../router';
import { UserProfile } from '@/models/userdata/profile';
import { SkillDocWrapper } from '@/models/skills/skilldocwrapper';
import { UserJob } from '@/models/jobs/userjob';
import { Job } from '@/models/jobs/job';
import { JobSkillType } from '@/models/skills/JobSkillType';
import { SkillType } from '@/models/userdata/skilltype';

@Component({
  name: 'AnonJobApplicationSuccess',
  components: {},
})
export default class AnonJobApplicationSuccess extends Vue {
  private userProfile: UserProfile = new UserProfile();
  public userSkills: SkillDocWrapper[] = [];
  public userJob: UserJob = new UserJob();
  private jobDetail: any[] = [];
  private jobDetailsError: string = '';
  public anonymousJob: Job = new Job();
  public jobSkills: string[] = [];
  public skillsNotExists: string[] = [];
  private jobSkillTypes: JobSkillType[] = [];
  private dbJobSkillTypes: SkillType[] = [];
  $wlToastr: any;

  redirectToSignupPage() {
    const userNameValue = this.$route.params.userName;
    router.push({
      name: 'LoginUniversalEntryPoint',
      params: { userName: userNameValue, postQuickApplySignupAction: 'true' },
    });
  }
}
